import { AutocompleteChangeValue, IAutocompleteOption } from 'edenred-ui';

import { IBeneficiary } from '@epi-models/pages/Beneficiaries';

export const isAutocompleteOption = (
  value: AutocompleteChangeValue
): value is IAutocompleteOption => {
  return (
    typeof value === 'object' &&
    value !== null &&
    'label' in value &&
    'value' in value
  );
};

export const isAutocompleteOptionArray = (
  value: AutocompleteChangeValue
): value is IAutocompleteOption[] => {
  return Array.isArray(value) && value.every(isAutocompleteOption);
};

export const getUniqueValuesArray = (
  beneficiaries: IBeneficiary[] | undefined,
  fieldAccessor: (b: IBeneficiary) => string | number | undefined
) => {
  if (!beneficiaries?.length) {
    return [];
  }
  return Array.from(
    new Set(
      beneficiaries
        .filter(b => fieldAccessor(b))
        .map(b => fieldAccessor(b) as string)
    )
  );
};
